// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowExpanderUp16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-expander-up': IconArrowExpanderUp;
    }
}

/**
 * The icon component for the 'arrowExpanderUp' icon
 */
export class IconArrowExpanderUp extends Icon {
    public constructor() {
        super(arrowExpanderUp16X16);
    }
}

registerIcon('icon-arrow-expander-up', IconArrowExpanderUp);
export const iconArrowExpanderUpTag = 'nimble-icon-arrow-expander-up';
